import { StyleSheet } from 'react-native';
import { neutrals, alert } from 'src/theme/colors';

export const style = StyleSheet.create({
  iconBadge: {
    width: 10,
    height: 10,
    borderRadius: 8,
    borderWidth: 2,
    backgroundColor: alert.alertRed,
    borderColor: neutrals.white,
    position: 'absolute',
    right: -2,
    top: -2,
  },
});
